/** @format */

import { CalendarComponent } from './calendar/calendar.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { EntryFormComponent } from './entry-form/entry-form.component';
import { SubmitSuccessModalComponent } from './submit-success-modal/submit-success-modal.component';
import { LogoutComponent } from './logout/logout.component';
import { TimeBankComponent } from './time-bank/time-bank.component';
import { Pagination } from './pagination/pagination.component';

export const components: any[] = [
	CalendarComponent,
	NavMenuComponent,
	EntryFormComponent,
	SubmitSuccessModalComponent,
	TimeBankComponent,
	LogoutComponent,
	Pagination,
];

export * from './calendar/calendar.component';
export * from './entry-form/entry-form.component';
export * from './nav-menu/nav-menu.component';
export * from './submit-success-modal/submit-success-modal.component';
export * from './time-bank/time-bank.component';
export * from './logout/logout.component';
export * from './pagination/pagination.component';
